// assets/past-work-guard.js
// Blocks "Past Work" from being added to cart unless another item is present.

(function () {
  const PAST_WORK_HANDLE = 'past-work';

  // ── Helpers ──────────────────────────────────────────────────────────────

  function getCart() {
    return fetch('/cart.js').then((r) => r.json());
  }

  function showMessage(anchorEl, msg) {
    let notice = anchorEl.parentElement.querySelector('.past-work-notice');
    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'past-work-notice';
      notice.style.cssText =
        'color:#c00;font-size:.875rem;margin:.5rem 0 0;font-weight:600;';
      anchorEl.parentElement.insertBefore(notice, anchorEl.nextSibling);
    }
    notice.textContent = msg;
  }

  function isPastWorkVariant(variantId) {
    // Cross-reference against the cart line's product handle
    return fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        // Used when we already know the handle from data attribute
        return false; // fallback — handled per call site
      });
  }

  async function cartHasCompanionItem(excludeVariantId) {
    const cart = await getCart();
    return cart.items.some(
      (item) =>
        item.handle !== PAST_WORK_HANDLE &&
        String(item.variant_id) !== String(excludeVariantId)
    );
  }

  // ── Collection page: intercept quick-add ─────────────────────────────────

  function guardCollectionPage() {
    // Dawn's quick-add uses <quick-add-bulk> or form[action="/cart/add"]
    // Listen at document level for submit on any add-to-cart form
    document.addEventListener(
      'submit',
      async function (e) {
        const form = e.target;
        if (form.getAttribute('data-type') !== 'add-to-cart-form') return;

        // Check if this form is for the past-work product
        // Dawn injects data-product-handle on the form's closest product card
        const card = form.closest('[data-product-handle]') ||
                     form.closest('[data-handle]');
        const handle = card?.dataset.productHandle || card?.dataset.handle;

        if (handle !== PAST_WORK_HANDLE) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        const variantId = form.querySelector('[name="id"]')?.value;
        const hasCompanion = await cartHasCompanionItem(variantId);

        if (!hasCompanion) {
          const btn = form.querySelector('[type="submit"]');
          showMessage(btn, '⚠ Add another item first — Past Work can only be purchased alongside another piece.');
        } else {
          // Companion present: allow the add
          form.submit();
        }
      },
      true // capture phase so we beat Dawn's own listener
    );
  }

  // ── Collection page: intercept fetch-based quick-add ─────────────────────
  // Dawn on collection pages POSTs to /cart/add via fetch, not a form submit.
  // We patch fetch to intercept those calls.

  const _fetch = window.fetch;
  window.fetch = async function (input, init) {
    const url = typeof input === 'string' ? input : input?.url || '';

    if (url.includes('/cart/add')) {
      const body = init?.body;
      let variantId = null;
      let handle = null;

      if (typeof body === 'string') {
        // URLSearchParams or JSON
        try {
          const params = new URLSearchParams(body);
          variantId = params.get('id') || params.get('items[0][id]');
        } catch (_) {}
        try {
          const json = JSON.parse(body);
          variantId = json.id || json.items?.[0]?.id;
        } catch (_) {}
      } else if (body instanceof FormData) {
        variantId = body.get('id') || body.get('items[0][id]');
      }

      if (variantId) {
        // Resolve whether this variant belongs to past-work
        const productRes = await _fetch(
          `/variants/${variantId}.js`
        ).catch(() => null);
        if (productRes?.ok) {
          const variant = await productRes.json();
          handle = variant?.product?.handle || variant?.url?.split('/products/')[1]?.split('?')[0];
          // Dawn's variant.js doesn't always return handle; use product endpoint
          if (!handle) {
            const prodRes = await _fetch(`/products.json?variant_id=${variantId}&limit=1`).catch(() => null);
            // Fallback: check cart after a tiny delay — not ideal. Skip for now.
          }

          // Better: fetch /products/past-work/variants/[id].js
          const pastWorkCheck = await _fetch(
            `/products/${PAST_WORK_HANDLE}.js`
          ).then((r) => r.json()).catch(() => null);

          if (pastWorkCheck) {
            const pastWorkVariantIds = pastWorkCheck.variants.map((v) => String(v.id));
            if (pastWorkVariantIds.includes(String(variantId))) {
              // This is a past-work add — check cart
              const hasCompanion = await cartHasCompanionItem(variantId);
              if (!hasCompanion) {
                // Find the button that triggered this and show message
                const btns = document.querySelectorAll(
                  `[data-product-handle="${PAST_WORK_HANDLE}"] [type="submit"], ` +
                  `[data-handle="${PAST_WORK_HANDLE}"] [type="submit"]`
                );
                btns.forEach((btn) => showMessage(btn, '⚠ Add another item first — Past Work can only be purchased alongside another piece.'));

                // Return a fake failed response
                return new Response(
                  JSON.stringify({ status: 422, description: 'Past Work requires a companion item in the cart.' }),
                  { status: 422, headers: { 'Content-Type': 'application/json' } }
                );
              }
            }
          }
        }
      }
    }

    return _fetch.apply(this, arguments);
  };

  // ── Init ──────────────────────────────────────────────────────────────────
  guardCollectionPage();
})();
